<template>
  <!--Has hover text that displays what the status is from nereus-->
  <div>
    <i
      v-if="iconValue"
      class="material-icons icon-color"
      aria-hidden="true"
      role="presentation"
      v-b-popover.hover.bottom="getStatusIndicatorText()"
    >{{getStatusIndicatorIcon()}}</i>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { iconNames } from '../../utils/constants';

export default {
  props: ['refDes', 'iconValue'],
  data() {
    return {
      iconNames,
    };
  },
  computed: {
    ...mapState({
      statusIndicators: (state) => state.statusIndicators,
    }),
  },
  methods: {
    // Helper method to filter through the statusIndicator information
    getStatusHelper() {
      let statusValue = _.get(this.statusIndicators, this.refDes);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorText() {
      const statusHolderText = this.getStatusHelper();
      const newStr = statusHolderText.replace(/-|_/g, ' ');
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'No status available';
      } else {
        text = newStr[0].toUpperCase() + newStr.substring(1);
      }
      return text;
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorIcon() {
      const statusHolder = this.getStatusHelper();
      return this.iconNames[statusHolder];
    },
  },
};
</script>

<style>
.icon-color {
  color: white !important;
  font-size: 1rem !important;
}
</style>
